export default class Category
{
  constructor(names, type) 
  {
    this.names = names; // {} instead of array to support stringify
    this.type = type;
  }    

  isValid()
  {
    var result = true;

    // Names
    for (const [key, value] of Object.entries(this.names)) {
      if(!value)
      {
        result = false;
        break;
      };
    }

    if(result) result = Boolean(this.type);

    return result;
  }
}